import { render, staticRenderFns } from "./InviteCodeForGroup.vue?vue&type=template&id=a84653e2&scoped=true&"
import script from "./InviteCodeForGroup.vue?vue&type=script&lang=js&"
export * from "./InviteCodeForGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84653e2",
  null
  
)

export default component.exports